export default "__VITE_ASSET__CQlBaBjy__"